import {TicketInfoDto} from '../../common/shared/api/gateway/TicketInfoDto.interface';
import {SingleTicketInfo} from '../generated/types';
import {createTicketType} from './TicketType';

export function createSingleTicketInfo({
  price,
  discount_price,
  ticket_type,
}: TicketInfoDto): SingleTicketInfo {
  return {
    ticketType: createTicketType(ticket_type),
    price,
    discountPrice: discount_price,
  };
}
